/*
 * File: ClinicalPageSubheader.js
 * Project: mp-mobile-app
 *
 * Copyright (c) 2019 MacPractice, Inc. All rights reserved.
 *
 * Description: Creates and styles the clinical header in the Widget Details
 */
import React from "react";
import { Theme, Toolbar } from "@material-ui/core";
import { withStyles } from "@material-ui/core/styles";
import MainHeader from "components/MainHeader";
import { WithStyles } from "@material-ui/styles";

const styles = (theme: Theme) => ({
  toolbar: {
    padding: theme.spacing(2.5),
    display: "block",
    marginTop: theme.spacing(2)
  }
});

interface Props extends WithStyles<typeof styles> {
  title: string;
  color: string;
}

const ClinicalPageSubheader = ({ title, color, classes }: Props) => (
  <div style={{ background: "#" + color }}>
    <Toolbar className={classes.toolbar}>
      <MainHeader pageTitle={title} pageSubtitle="Clinical" clinical />
    </Toolbar>
  </div>
);

export default withStyles(styles)(ClinicalPageSubheader);
